// ローディング画面
export function commonFunc() {
  const loading = document.querySelector("#loading");
  if (!loading) return;

  const hideLoading = () => {
    loading.classList.add("loaded");
  };

  // commonFunc() が load 後に呼ばれても動くようにする
  if (document.readyState === "complete") {
    hideLoading();
    return;
  }

  window.addEventListener("load", hideLoading, { once: true });
}
